export default theme => ({
    content: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'center',
        margin: theme.spacing(2),
    },
    message: {
        maxWidth: '650px',
        wordWrap: 'break-word',
    },
});
